const EaseOutIcon = /*#__PURE__*/ [
  ["path", { d: "M3 20C3 20 10 4 21 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { EaseOutIcon as default };
//# sourceMappingURL=EaseOutIcon.js.map
